import $ from "jquery";
import plugin from "@core/plugins/lib";
import { onAvailable } from '@core/plugins/lib/selectors';

const ELEMENT_SELECTOR = '[data-validate-form]';
const PLUGIN_NAME = 'validateForm';

$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function(element) {
		System.import(/* webpackChunkName: "validate-form" */ './validate-form').then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/form-validation/plugin--available.js